import { Cirus } from "@/classes/Http";
import { AxiosResponse } from "axios";

enum TimeScope {
    DAY= 'day',
    WEEK= 'week',
    MONTH= 'month',
    YEAR= 'year'
}

const scopeToDay  = {
    'day': 1,
    'week': 7,
    'month': 30,
    'year': 365
}

class Day {
    count: number;
    date: Date;
    day_of_month: number;
}

class GetInstanceStatsBoughtSoldResponse {
    bought_series: Day[];
    sold_series: Day[];
}

export function getInstanceStatsBoughtSoldSeries(instance_id: number, time_scope = TimeScope.DAY, time_scale=30, page = 1): Promise<AxiosResponse<GetInstanceStatsBoughtSoldResponse>>{
    const days = scopeToDay[time_scope]*time_scale;
    return Cirus.get(`/instance/${instance_id}/stats/bought-sold-series?days=${days}&page=${page}`);
}